export const UNAVAILABILITY_REDIRECT_COOKIE = 'unavailabilityRedirectCookie';
export const REDUCTION_REDIRECT_COOKIE = 'reductionRedirectCookie';
export const APP_BANNER_COOKIE = 'appBannerCookie';
export const BOAT_DETAIL_QUERY_STRING_COOKIE = 'BOAT_DETAIL_QUERY_STRING_COOKIE';
export const GDPR_COOKIE = 'gdpr';
// FIXME: (TPP-1626) Remove the YW constant.
export const YACHTWORLD_JAVA_BDP_COOKIE = 'yw_java_ab';
export const SAVE_SEARCH_MODAL_SHOWN = 'saveSearchModalShown';
